exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.in[data-v-d644dc42] {\n  display: block;\n}\n", ""]);

// exports
